<template>
  <div>
    <el-dialog
      top="0"
      class="dialog_account_adjustment"
      width="90%"
      title="账单调账"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      @open="handleOpen"
    >
      <template #title>
        <div>
          <div class="account_adjustment_dialog_title">账单调账</div>
          <div class="account_adjustment_dialog_text">{{detailInfo.businessName ||'-'}}</div>
        </div>
      </template>
      <div class="dialog__body">
        <div class="account_adjustment_box" ref="accountAdjustmentBoxRef">
          <div class="account_adjustment_left">
            <div ref="accountAdjustmentLeftHeaderRef">
              <jr-search2
                :form-list="formList"
                :search-value.sync="queryLeftForm"
                :loading="leftLoading"
                @search="handleLeftSearch"
                @reset="handleLeftReset"
                trackCode='baibuBillDisburseList-1'
              >
                <template #applyTypeSlotName>
                  <page-select-groups :search-value.sync="queryLeftForm" @change="refreshLeftList" :selectList="selectList" />
                </template>
              </jr-search2>
            </div>
            <el-table
              ref="accountAdjustmentLeftTableRef"
              key="accountAdjustmentLeftTable"
              class="jr_table_left"
              :data="leftTableShowList"
              :height="tableLeftHeight"
              @selection-change="handleSelectionLeftChange"
            >
              <el-table-column label="未生成账单" align="center">
                <el-table-column type="selection" width="40" :selectable="handleSelectable"></el-table-column>
                <el-table-column label="业务订单编号" min-width="80">
                  <template slot-scope="{row}">{{ row.orderNumber }}</template>
                </el-table-column>
                <el-table-column label="流水类型" min-width="60">
                  <template slot-scope="{row}">
                    <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.applyTypeDesc}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="收款单金额" min-width="60">
                  <template slot-scope="{row}">
                    <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.receiptAmount | toFenThousandsAndFloat}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="创建时间" min-width="80">
                  <template slot-scope="{row}">{{ row.createTime | formatTime}}</template>
                </el-table-column>
                <el-table-column label="申请人" min-width="40">
                  <template slot-scope="{row}">{{ row.createUser }}</template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
          <div class="account_adjustment_btn_group">
            <div>
              <el-button type="primary" size="mini" icon="el-icon-arrow-right" @click="handleOpenAccountAdjustment('add')"></el-button>
            </div>
            <div>
              <el-button type="primary" size="mini" icon="el-icon-arrow-left" @click="handleOpenAccountAdjustment('remove')"></el-button>
            </div>
          </div>
          <div class="account_adjustment_right">
            <div ref="accountAdjustmentRightHeaderRef">
              <jr-search2
                :form-list="formList"
                :search-value.sync="queryRightForm"
                :loading="rightLoading"
                @search="handleRightSearch"
                @reset="handleRightReset"
                trackCode='baibuBillDisburseList-1'
              >
                <template #applyTypeSlotName>
                  <page-select-groups :search-value.sync="queryRightForm" @change="refreshRightList" :selectList="selectList" />
                </template>
              </jr-search2>
            </div>
            <el-table
              ref="accountAdjustmentRightTableRef"
              key="accountAdjustmentRightTable"
              class="jr_table_right"
              :data="rightTableShowList"
              :height="tableRightHeight"
              @selection-change="handleSelectionRightChange"
            >
              <el-table-column label="本期账单" align="center">
                <el-table-column type="selection" width="40" :selectable="handleSelectable"></el-table-column>
                <el-table-column label="业务订单编号" min-width="80">
                  <template slot-scope="{row}">{{ row.orderNumber }}</template>
                </el-table-column>
                <el-table-column label="流水类型" min-width="60">
                  <template slot-scope="{row}">
                    <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.applyTypeDesc}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="收款单金额" min-width="60">
                  <template slot-scope="{row}">
                    <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.receiptAmount | toFenThousandsAndFloat}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="回款状态" min-width="60">
                  <template slot-scope="{row}">
                    <status
                      type="dot"
                      :color="setStatusColor(row.repaymentStatus, 'repaymentStatus')"
                      :text="row.repaymentStatusDesc || '-'"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="创建时间" min-width="80">
                  <template slot-scope="{row}">{{ row.createTime | formatTime}}</template>
                </el-table-column>
                <el-table-column label="申请人" min-width="40">
                  <template slot-scope="{row}">{{ row.createUser }}</template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()" :size="formSize">取消</el-button>
        <el-button type="primary" :size="formSize" :loading="submitLoading" @click="submit()">保存</el-button>
      </span> -->
    </el-dialog>
    <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="subAccountObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="handleSetAccountAdjustment"
    />
  </div>
</template>

<script>
import { getBillAdjustList, setBillAdjust } from '@/api/baibu-bill';
import { getMonthDate } from '@/utils/date';
import NP from 'number-precision';
import { setStatusColor } from '@/filters/index';

const queryFormDefault = {
  timeType: '1', // 时间类型
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  applyType: '', // 流水类型
  billNo: '', // 账单编号
  listType: '', // 列表类型: ORIGINAL 未生成账单,NOW 本期账单
  searchContent: '', // 搜索内容-不支持模糊查询,批量查询时以逗号分隔
  searchType: '1', // 搜索类型：1-业务订单号,2-收款单号,3-申请单号
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    billNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            { value: '1', label: '业务订单编号' },
          ],
        },
        { slot: 'applyTypeSlotName' },
      ],
      selectList: [
        {
          title: '流水类型',
          prop: 'applyType',
          dictionaryPath: '/finance/finance-receipt/ApApplyTypeEnum',
        },
      ],
      boxHeight: 0, // 外壳高度
      isSetBill: false, // 是否调账过
      /** ------- 左边参数开始 -------- */
      leftLoading: false,
      queryLeftForm: JSON.parse(JSON.stringify(queryFormDefault)),
      leftTableShowList: [],
      tableLeftHeight: 'auto',
      multipleLeftSelection: [],
      /** ------- 左边参数结束 -------- */

      /** ------- 右边参数开始 -------- */
      rightLoading: false,
      queryRightForm: JSON.parse(JSON.stringify(queryFormDefault)),
      rightTableShowList: [],
      rightTableAllList: [], // 右边所有数据
      tableRightHeight: 'auto',
      multipleRightSelection: [],
      /** ------- 右边参数结束 -------- */


      /** ------移入移出本期账单操作-------- */
      isOperateStateShow: false, // 启用禁用弹窗
      submitLoading: false,
      textConfig: {}, // 弹窗页面提示文案
      subAccountObj: {}, // 启用禁用对象
      setStatusColor,
    };
  },
  computed: {
    // 收款单金额为负，且高亮展示；
    isTextRed() {
      return (val) => {
        if (val && val < 0) {
          return true;
        }
        return false;
      };
    },
  },
  watch: {
    tableLeftHeight() {
      if (this.$refs.accountAdjustmentLeftTableRef) {
        this.$refs.accountAdjustmentLeftTableRef.doLayout();
      }
    },
    tableRightHeight() {
      if (this.$refs.accountAdjustmentRightTableRef) {
        this.$refs.accountAdjustmentRightTableRef.doLayout();
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleSetTableHeight, false);
  },
  // 离开页面后的逻辑处理
  destroyed() {
    // 在组件或者页面卸载的地方删除监听
    window.removeEventListener('resize', this.handleSetTableHeight);
  },
  methods: {
    // 仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    handleSelectable(row) {
      // 回款流水REPAYMENT禁止选择
      if (row.applyType === 'REPAYMENT') {
        return false;
      }
      return true;
    },
    // 移入移出操作请求接口(调账操作接口)
    async handleSetAccountAdjustment(params) {
      try {
        this.submitLoading = true;
        console.log(params);
        await setBillAdjust(params);
        this.$message({ message: '账单调账成功！！', type: 'success' });
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.isSetBill = true;
        this.handleTableApi();
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
    /**
     * 操作: add 加入本期账单,remove 移出本期账单
     * 移入本期账单:operate=add;
     * 移出本期账单:operate=remove;
    */
    handleOpenAccountAdjustment(operate) {
      if (operate === 'add' && !(this.multipleLeftSelection && this.multipleLeftSelection.length > 0)) {
        this.$message({ message: '请选择移入账单', type: 'warning' });
        return;
      }
      if (operate === 'remove' && !(this.multipleRightSelection && this.multipleRightSelection.length > 0)) {
        this.$message({ message: '请选择移出账单', type: 'warning' });
        return;
      }
      const receiptNos = ((operate === 'add' ? this.multipleLeftSelection : this.multipleRightSelection) || []).map((item) => item.receiptNo) || [];
      this.subAccountObj = {
        billNo: this.billNo,
        operate,
        receiptNos,
      };
      const list = {
        remove: {
          title: '人工处理',
          messageTip: '是否移出本期账单？',
          isPass: true,
        },
        add: {
          title: '人工处理',
          messageTip: '是否移入本期账单？',
          isPass: true,
        },
      };
      this.textConfig = list[operate] || '-';
      this.isOperateStateShow = true;
    },
    // 设置左右table内容高度
    handleSetTableHeight() {
      this.tableLeftHeight = 'auto';
      this.tableRightHeight = 'auto';
      this.handleLeftTableHeight();
      this.handleRightTableHeight();
    },
    // 关闭
    handleClose() {
      // true:调账, false:未调账
      this.$emit('isSetBill', this.isSetBill);
      this.$emit('update:visible', false);
      this.submitLoading = false;
    },
    // 打开窗口前
    handleOpen() {
      this.isSetBill = false;
      this.handleTableApi();
      this.$nextTick(() => {
        const { accountAdjustmentBoxRef } = this.$refs;
        if (accountAdjustmentBoxRef) {
          this.boxHeight = accountAdjustmentBoxRef.clientHeight || 0;
        }
        console.log('=boxHeight========', this.boxHeight);
        this.handleSetTableHeight();
      });
    },
    // 请求左右两边接口数据
    handleTableApi() {
      this.handleLeftReset();// 左边
      this.handleRightReset();// 右边
    },
    /** ------------左边方法开始-------------- */
    // 左边=>选择多选框返回
    handleSelectionLeftChange(val) {
      this.multipleLeftSelection = val;
    },
    // 左边=>计算内容高度
    handleLeftTableHeight() {
      this.$nextTick(() => {
        const { accountAdjustmentLeftHeaderRef } = this.$refs;
        let headerH = 0;
        if (accountAdjustmentLeftHeaderRef) {
          headerH = accountAdjustmentLeftHeaderRef.clientHeight || 0;
        }
        const h = NP.minus(this.boxHeight, headerH);
        this.tableLeftHeight = h && h > 0 ? h : 'auto';
      });
    },
    // 左边=>重置时间的默认值
    resetLeftDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryLeftForm.beginTime = startDate || '';
      this.queryLeftForm.endTime = endDate || '';
    },
    // 左边=>重置搜索条件
    handleLeftReset() {
      this.queryLeftForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.resetLeftDate();
      this.getLeftList();
    },
    // 左边=>列表查询
    handleLeftSearch(params = {}) {
      this.queryLeftForm = { ...this.queryLeftForm, ...params, page: 1 };
      this.getLeftList();
    },
    // 左边=>列表刷新
    refreshLeftList() {
      this.queryLeftForm.page = 1;
      this.getLeftList();
    },
    // 左边=>列表接口请求
    async getLeftList() {
      try {
        const params = JSON.parse(JSON.stringify(this.queryLeftForm));
        this.leftLoading = true;
        this.leftTableShowList = [];
        // listType=列表类型: ORIGINAL 未生成账单,NOW 本期账单
        const res = await getBillAdjustList({ ...params, listType: 'ORIGINAL', billNo: this.billNo });
        this.leftTableShowList = res.data || [];
      } catch (error) {
        console.log(error);
        this.leftLoading = false;
        this.leftTableShowList = [];
      } finally {
        this.leftLoading = false;
      }
    },
    /** ------------左边方法结束-------------- */

    /** ------------右边方法开始-------------- */
    // 右边=>选择多选框返回
    handleSelectionRightChange(val) {
      this.multipleRightSelection = val;
    },
    // 右边=>计算内容高度
    handleRightTableHeight() {
      this.$nextTick(() => {
        const { accountAdjustmentRightHeaderRef } = this.$refs;
        let headerH = 0;
        if (accountAdjustmentRightHeaderRef) {
          headerH = accountAdjustmentRightHeaderRef.clientHeight || 0;
        }
        const h = NP.minus(this.boxHeight, headerH);
        this.tableRightHeight = h && h > 0 ? h : 'auto';
      });
    },
    // 右边=>重置时间的默认值
    resetRightDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryRightForm.beginTime = startDate || '';
      this.queryRightForm.endTime = endDate || '';
    },
    // 右边=>重置搜索条件
    handleRightReset() {
      this.queryRightForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.resetRightDate();
      this.getRightList();
    },
    // 右边=>列表查询
    handleRightSearch(params = {}) {
      this.queryRightForm = { ...this.queryRightForm, ...params, page: 1 };
      this.getRightList();
    },
    // 右边=>列表刷新
    refreshRightList() {
      this.queryRightForm.page = 1;
      this.getRightList();
    },
    // 右边=>列表接口请求
    async getRightList() {
      try {
        const params = JSON.parse(JSON.stringify(this.queryRightForm));
        this.rightLoading = true;
        this.rightTableShowList = [];
        // listType=列表类型: ORIGINAL 未生成账单,NOW 本期账单
        const res = await getBillAdjustList({ ...params, listType: 'NOW', billNo: this.billNo });
        this.rightTableShowList = res.data || [];
      } catch (error) {
        console.log(error);
        this.rightLoading = false;
        this.rightTableShowList = [];
      } finally {
        this.rightLoading = false;
      }
    },
    /** ------------右边方法结束-------------- */
  },

};
</script>

<style lang="scss" scoped>
.dialog_account_adjustment {
  height: 100%;
  margin-top: 5%;
  ::v-deep {
    .el-dialog {
      min-width: 1000px;
      max-width: 100%;
      min-height: 90%;
      height: 90%;
      display: flex;
      flex-direction: column;
    }
    .el-dialog__body {
      flex: 1;
      padding: 20px !important;
    }
    .dialog__body {
      height: 100%;
    }
    .jr_table_left, .jr_table_right {
      width: 100%;
    }
  }
  .account_adjustment_box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    .account_adjustment_left, .account_adjustment_right {
      height: 100%;
      flex: 1;
      width: calc(100% / 2 - 54px);
    }
    .account_adjustment_btn_group {
      margin: 8px;
      .el-button {
        margin: 8px;
        min-width: 36px;
        height: 36px;
        font-weight: bolder;
        font-size: 16px;
      }
    }
  }
}
.account_adjustment_dialog_title {
  line-height: 24px;
  font-size: 18px;
  color: #272728;
  font-weight: bolder;
}
.account_adjustment_dialog_text {
  font-size: 14px;
  color: #272728;
  margin-top: 8px;
  font-weight: bolder;
}
</style>
